export const formatPrice = (price: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(price);
};

export const formatDate = (date: string): string => {
  return new Date(date).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
};

export const formatRelativeTime = (timestamp: string): string => {
  const date = new Date(timestamp);
  const now = new Date();
  const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

  if (diffInSeconds < 60) {
    return 'Just now';
  }

  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 60) {
    return `${diffInMinutes}m ago`;
  }

  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) {
    return `${diffInHours}h ago`;
  }

  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 7) {
    return `${diffInDays}d ago`;
  }

  return formatDate(timestamp);
};

export const getCreditScoreRange = (scoreRange: string): string => {
  switch (scoreRange) {
    case '850-800':
      return 'Excellent (800-850)';
    case '799-740':
      return 'Very Good (740-799)';
    case '739-670':
      return 'Good (670-739)';
    case '669-580':
      return 'Fair (580-669)';
    case '579-300':
      return 'Poor (300-579)';
    default:
      return 'Not provided';
  }
};

export const getIncomeRange = (incomeRange: string): string => {
  if (!incomeRange) return 'Not provided';
  if (incomeRange === '10000+') return '$10,000+';
  const [min, max] = incomeRange.split('-');
  return `$${parseInt(min).toLocaleString()} - $${parseInt(max).toLocaleString()}`;
};

export const getCreditScoreColor = (score: number): string => {
  if (score >= 800) return 'text-green-600';
  if (score >= 740) return 'text-green-500';
  if (score >= 670) return 'text-yellow-500';
  if (score >= 580) return 'text-orange-500';
  return 'text-red-500';
};